import { GET_TERMS } from '@/app/Api/Route_API';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '@/utils/axiosInstance';

export const getTerms = createAsyncThunk(
  'terms/getterms',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_TERMS);
      if (response?.data?.status === true) {
        return response?.data?.data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Slice
const termAndPolicySlice = createSlice({
  name: 'terms',
  initialState: {
    data: [], // Changed from 'price' to 'data' for better naming
    privacyPolicy: null,
    termsOfService: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTerms.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getTerms.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = 'succeeded';
        state.error = null;
        
        // Separate privacy policy and terms data
        if (action.payload && Array.isArray(action.payload)) {
          state.privacyPolicy = action.payload.find(item => item.type === 'privacy');
          state.termsOfService = action.payload.find(item => item.type === 'terms');
        }
      })
      .addCase(getTerms.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default termAndPolicySlice.reducer;